import {GeoTrack} from '../Models/GeoTrack';

/**
 * Calculate the center point of a GeoTrack.
 * @param geoTrack The track of which to determine the center point.
 * @returns A dictionary containing a lat and lng indicating the center point.
 */
export function centerPointOfGeoTrack(geoTrack: GeoTrack): {lat: number; lng: number} {
    if (geoTrack.length === 0) {
        //Lat and lng of factory in Haaksbergen
        return {lat: 52.1743125, lng: 6.7415037};
    }
    let totalLat = 0;
    let totalLng = 0;
    const totalPoints = geoTrack.length;

    // Calculate the sum of latitudes and longitudes
    for (const {lat, lng} of geoTrack) {
        totalLat += lat;
        totalLng += lng;
    }

    // Calculate the average latitude and longitude
    const avgLat = totalLat / totalPoints;
    const avgLng = totalLng / totalPoints;

    // Convert average latitude and longitude to radians
    const avgLatRad = (avgLat / 180) * Math.PI;
    const avgLngRad = (avgLng / 180) * Math.PI;

    // Calculate the center point using the haversine formula
    const x = Math.cos(avgLatRad) * Math.cos(avgLngRad);
    const y = Math.cos(avgLatRad) * Math.sin(avgLngRad);
    const z = Math.sin(avgLatRad);

    const centerLngRad = Math.atan2(y, x);
    const centerLatRad = Math.atan2(z, Math.sqrt(x * x + y * y));

    // Convert center latitude and longitude back to degrees
    const centerLat = (centerLatRad / Math.PI) * 180;
    const centerLng = (centerLngRad / Math.PI) * 180;

    return {lat: centerLat, lng: centerLng};
}
